import React from 'react';
import { useState } from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { DashboardNavbar } from './dashboard-navbar';
import { DashboardSidebar } from './dashboard-sidebar';
import { BackMenu } from './backMenu';

const DashboardLayoutRoot = styled('div')(({ theme }) => ({
	display: 'flex',
	flex: '1 1 auto',
	maxWidth: '100%',
	height: '100%',
	[theme.breakpoints.up('lg')]: {
		paddingLeft: 278,
	},
}));

export default (props) => {
	const { instagram, children, title, icon, head, user, isAgent, subtitle, disabled } = props;
	const [isSidebarOpen, setSidebarOpen] = useState(false);
	return (
		<>
			<DashboardLayoutRoot
				style={{
					paddingTop: disabled ? 0 : 52,
				}}
			>
				<Box
					sx={{
						display: 'flex',
						flex: '1 1 auto',
						flexDirection: 'column',
						width: '100%',
					}}
				>
					{children}
				</Box>
			</DashboardLayoutRoot>
			{!disabled && <DashboardNavbar head={head} icon={icon} subtitle={subtitle} title={title} onSidebarOpen={() => setSidebarOpen(true)} />}
			{disabled && <BackMenu onSidebarOpen={() => setSidebarOpen(true)} />}
			<DashboardSidebar instagram={instagram} user={user} isAgent={isAgent} onClose={() => setSidebarOpen(false)} open={isSidebarOpen} />
		</>
	);
};
